import {Navigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Skeleton} from '@/components/ui/skeleton'
import {ListEmptyState} from '@/components/section-card'
import {AdminAtencionPage} from '@/pages/inci/consola/admin-atencion'
import {useBusinesses, useIsSystemUser} from '@/hooks/empresa/organizacion/use-businesses'
import {LAST_BUSINESS_KEY} from '@/lib/constants'

export function HomePage() {
  const isSystemUser = useIsSystemUser()
  if (isSystemUser) return <AdminAtencionPage />
  return <MembershipRedirect />
}

function MembershipRedirect() {
  const {t} = useTranslation()
  const {data, isLoading} = useBusinesses({page: 1, search: '', sortBy: 'name', sortDir: 'asc'})

  if (isLoading || !data) return <Skeleton className="h-40 w-full" />
  if (!data.items.length)
    return (
      <div className="surface">
        <ListEmptyState page title={t('businesses.emptyTitle')} body={t('businesses.emptyBody')} />
      </div>
    )

  const lastVisited = localStorage.getItem(LAST_BUSINESS_KEY)
  const target = data.items.find((b) => b.id === lastVisited) ?? data.items[0]
  return <Navigate to={`/businesses/${target.id}`} replace />
}
